import { Reveal, ChapterHead } from "./Reveal";
import { useContent } from "@/content";

const CAPACITIES = [
  { n: "01", t: "IMAGINE ALTERNATIVES", d: "See possibilities beyond what currently exists." },
  { n: "02", t: "CONNECT UNRELATED IDEAS", d: "Thinking that moves across subjects instead of staying inside one field." },
  { n: "03", t: "QUESTION INHERITED SYSTEMS", d: "The world you inherit is still editable." },
  { n: "04", t: "CREATE SOLUTIONS", d: "Understand technology instead of simply consuming it." },
  { n: "05", t: "DEVELOP AN ORIGINAL VOICE", d: "A perspective that exists outside the algorithm." },
];

export const NextGeneration = () => {
  const c = useContent();

  return (
    <section id="next-generation" className="bg-[#EDF2FF] text-[#05070F]" data-testid="next-generation-section">
      <div className="px-6 sm:px-12 lg:px-20 py-24 sm:py-32 max-w-7xl mx-auto">
        <ChapterHead index="CHAPTER 05" title="THE NEXT GENERATION" inverted />

        <Reveal>
          <p className="font-meta text-xs tracking-[0.3em] text-black/50 mb-8">THE CENTERPIECE</p>
          <p
            className="font-display font-extrabold uppercase tracking-tighter leading-[1.02] text-[clamp(1.8rem,5.2vw,4.5rem)] max-w-6xl"
            data-testid="next-gen-centerpiece"
          >
            {c.nextgen_centerpiece || "“I do not want the next generation trained only to consume the future. I want them capable of creating it.”"}
          </p>
        </Reveal>

        <Reveal delay={0.1}>
          <p className="text-base sm:text-lg font-light leading-relaxed text-black/70 mt-12 max-w-3xl">
            {c.nextgen_text || "Young people are growing up surrounded by algorithms, AI, constant media, and endless digital consumption. Creative thinking is the way through — and creative thinking is more than art. It is a discipline of the mind."}
          </p>
        </Reveal>

        <div className="mt-16 sm:mt-20">
          {CAPACITIES.map((cap, i) => (
            <Reveal key={cap.n} delay={i * 0.04}>
              <div className="grid grid-cols-12 gap-4 items-baseline border-t border-black/15 py-6 sm:py-8 group hover:bg-[#0A1230] hover:text-white transition-colors duration-300 px-2 sm:px-4 -mx-2 sm:-mx-4">
                <span className="col-span-2 sm:col-span-1 font-meta text-xs tracking-[0.25em] text-black/40 group-hover:text-blue-300/70 transition-colors duration-300">
                  {cap.n}
                </span>
                <h3 className="col-span-10 sm:col-span-5 font-display text-xl sm:text-2xl lg:text-3xl font-bold uppercase tracking-tight">
                  {cap.t}
                </h3>
                <p className="col-span-12 sm:col-span-6 text-sm sm:text-base font-light text-black/60 group-hover:text-blue-100/70 transition-colors duration-300 sm:text-right">
                  {cap.d}
                </p>
              </div>
            </Reveal>
          ))}
          <div className="border-t border-black/15" />
        </div>
      </div>
    </section>
  );
};
